import React from 'react';
import './../styles/index.css';

import { Row, Button, Col } from 'react-bootstrap';
import { RiCloseCircleFill, RiCheckboxCircleFill } from 'react-icons/ri';

import ConfirmBox from './confirmBox'


export default function EmptyGridButton(props) {

    const { selectCombi } = props; //to pass combi back to the parent playsound.js

    const restart = () => {
        //pass nothing for combination and reshuffle flag to the playsound.js
        selectCombi("", "restart");
    }

    const newGame = () => {

        //pass nothing for combination and reshuffle flag to the playsound.js
        selectCombi("", "newgame");
    }




    var rows = [];
    for (var i = 0; i < 25; i++) {
        rows.push(i);
    }

    //getting callback from confirmbox if user wants to restart or new game
    const onSelectConfirm = (status) => {
        if (status === "restart") {
            restart();
        }
        if (status === "newgame") {
            newGame();
        }

    }

    return (

        <div>
            <Row className="timer-gap">
                <Col xs={3} className="text-end ">
                    <Button className="resetButton" disabled >
                        < RiCloseCircleFill size={`${window.outerWidth > 576 ? '50' : '40'}`} />
                    </Button>
                </Col>
                <Col className="transparentBackground previewText">
                    <>
                        &nbsp;
                    </>
                </Col>

                <Col xs={3} className="text-start ">
                    <Button className="submitButton" disabled >< RiCheckboxCircleFill size={`${window.outerWidth > 576 ? '50' : '40'}`} /></Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    {
                        rows.map((item, index) => {


                            return (
                                <React.Fragment key={index}>
                                    <Button className="gridButton" disabled key={index}>&nbsp;</Button>
                                    {(index + 1) % 5 === 0 && <><br /></>}
                                </React.Fragment>
                            );
                        })
                    }
                </Col>
            </Row>

            <Row>
                <Col className="d-flex justify-content-center">
                    {/* <Button className="bottomButton" disabled>Reshuffle</Button> */}
                    <ConfirmBox selectConfirm= {onSelectConfirm} button="Restart" header="Restart Game with same settings?" content="Do you want to continue? All submitted results will be removed." option="restart" />
                    <ConfirmBox selectConfirm= {onSelectConfirm} button="New Game" header="Restart Game with new settings?" content="Do you want to continue? All submitted results will be removed." option="newgame" />
                </Col>
            </Row>

        </div>
    )
}